var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400 800C620.914 800 800 620.914 800 400C800 179.086 620.914 0 400 0C179.086 0 0 179.086 0 400C0 620.914 179.086 800 400 800Z",
    fill: "url(#paint0_linear_71_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.17 241.351C468.735 228.147 464.213 211.282 451.07 203.682C437.928 196.082 421.14 200.626 413.575 213.83L400.383 236.861L387.188 213.83C379.623 200.626 362.835 196.082 349.693 203.682C336.55 211.282 332.028 228.147 339.593 241.351L368.7 292.16L276.63 452.873H202.458C187.293 452.873 175 465.223 175 480.458C175 495.693 187.293 508.043 202.458 508.043H460.81C463.075 502.063 465.46 491.803 462.922 482.373C459.11 468.198 445 452.873 421.355 452.873H339.993L461.17 241.351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.91 538.547C286.225 533.32 275.73 524.967 266.525 522.22C252.493 518.027 241.853 520.657 236.486 522.947L216.033 558.65C208.469 571.852 212.991 588.717 226.134 596.317C239.277 603.917 256.063 599.375 263.628 586.17L290.91 538.547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.738 508.043H597.543C612.708 508.043 625 495.693 625 480.458C625 465.223 612.708 452.873 597.543 452.873H524.133L441.438 308.528C435.295 314.393 423.518 329.375 421.738 346.363C419.45 368.2 422.88 386.59 433.178 404.598C467.795 465.14 502.468 525.655 537.135 586.17C544.7 599.375 561.485 603.918 574.63 596.318C587.773 588.718 592.295 571.853 584.73 558.65L555.738 508.043Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_71_2",
    x1: 400,
    y1: 0,
    x2: 400,
    y2: 800,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AC9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F65EB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/appStore.44fb59df1192a9a8c199474ad77eaabd.svg";
export { ForwardRef as ReactComponent };